module.exports = __webpack_public_path__ + "media/images/tic@2x-cd79b149ae7edf400317df0060bcbc3a.png";